import React, { useState } from 'react';
import { ReactComponent as Magnifier } from "../../assets/icons/Magnifier.svg";

function SearchBar({ onSearch, placeholder, classes, mbZero = false, pbZero = false }) {
    const handleSearch = (event) => {
        const searchTerm = event.target.value;
        onSearch(searchTerm);
    };

    return (
        <div className={`${pbZero ? "pb-0" : "pb-3"} flex items-center relative`}>
            <Magnifier className={`absolute ${mbZero ? "mb-0" : "mb-3"} mx-3 sm:left-0 sm:right-0 `} />
            <input
                type="text"
                placeholder={placeholder ?? "Search"}
                className={classes ?? `border-input border w-full bg-inputInterface text-f16 p-2 px-11 ${mbZero ? "mb-0" : "mb-3"} shadow-search rounded`}
                onChange={handleSearch}
            />
        </div>
    );
}

export default SearchBar;
